import { defineMessages } from 'react-intl';

const messages = defineMessages({
  pageTitle: {
    id: 'orderCancellation.pageTitle',
    defaultMessage: 'Cancellation and return form',
  },
  routeLinkLabel: {
    id: 'orderCancellation.routeLinkLabel',
    defaultMessage: 'Return form',
  },
  intro: {
    id: 'orderCancellation.intro',
    defaultMessage:
      'Use this form to send a cancellation notice. Fill in the required fields marked with a red asterisk (*).',
  },
  termsOfDeliveryLinkLabel: {
    id: 'orderCancellation.termsOfDeliveryLinkLabel',
    defaultMessage: 'Terms of delivery',
  },
  detailsStepTitle: {
    id: 'orderCancellation.detailsStepTitle',
    defaultMessage: 'Fill in the required details',
  },
  confirmStepTitle: {
    id: 'orderCancellation.confirmStepTitle',
    defaultMessage: 'Review and submit',
  },
  confirmStepNotice: {
    id: 'orderCancellation.confirmStepNotice',
    defaultMessage: 'Review the details once more before sending.',
  },
  successTitle: {
    id: 'orderCancellation.successTitle',
    defaultMessage: 'Cancellation notice sent',
  },
  successMessage: {
    id: 'orderCancellation.successMessage',
    defaultMessage:
      'Your cancellation notice has been sent. Customer service will process it and contact you if more information is needed.',
  },
  loadOrderFallback: {
    id: 'orderCancellation.loadOrderFallback',
    defaultMessage:
      'Order details are not available in this session. You can still send the cancellation notice manually.',
  },
  loadOrderSuccess: {
    id: 'orderCancellation.loadOrderSuccess',
    defaultMessage:
      'Order details from your current session were used to prefill the cancellation and return form for review.',
  },
  emailLabel: {
    id: 'orderCancellation.emailLabel',
    defaultMessage: 'Email address',
  },
  orderIdentifierLabel: {
    id: 'orderCancellation.orderIdentifierLabel',
    defaultMessage: 'Order number',
  },
  cancellationScopeLabel: {
    id: 'orderCancellation.cancellationScopeLabel',
    defaultMessage: 'What would you like to do?',
  },
  cancelWholeOrderOption: {
    id: 'orderCancellation.cancelWholeOrderOption',
    defaultMessage: 'Cancel the entire order',
  },
  cancelPartOfOrderOption: {
    id: 'orderCancellation.cancelPartOfOrderOption',
    defaultMessage: 'Return products from the order',
  },
  productDescriptionLabel: {
    id: 'orderCancellation.productDescriptionLabel',
    defaultMessage: 'Products you want to return',
  },
  productDescriptionHelp: {
    id: 'orderCancellation.productDescriptionHelp',
    defaultMessage:
      'Describe the product as best as you can. eg. write product name and number. Additionally write the quantity of each product you want to return.',
  },
  additionalMessageLabel: {
    id: 'orderCancellation.additionalMessageLabel',
    defaultMessage: 'Additional message',
  },
  privacyStatementLabel: {
    id: 'orderCancellation.privacyStatementLabel',
    defaultMessage: 'I accept the privacy statement',
  },
  nextStep: {
    id: 'orderCancellation.nextStep',
    defaultMessage: 'Continue',
  },
  backToEdit: {
    id: 'orderCancellation.backToEdit',
    defaultMessage: 'Back',
  },
  confirmAndSend: {
    id: 'orderCancellation.confirmAndSend',
    defaultMessage: 'Send',
  },
  summaryEmail: {
    id: 'orderCancellation.summaryEmail',
    defaultMessage: 'Email',
  },
  summaryOrderIdentifier: {
    id: 'orderCancellation.summaryOrderIdentifier',
    defaultMessage: 'Order number',
  },
  summaryScope: {
    id: 'orderCancellation.summaryScope',
    defaultMessage: 'Cancellation scope',
  },
  summaryProducts: {
    id: 'orderCancellation.summaryProducts',
    defaultMessage: 'Products',
  },
  summaryAdditionalMessage: {
    id: 'orderCancellation.summaryAdditionalMessage',
    defaultMessage: 'Additional message',
  },
  wholeOrderSummaryValue: {
    id: 'orderCancellation.wholeOrderSummaryValue',
    defaultMessage: 'Entire order',
  },
  partialOrderSummaryValue: {
    id: 'orderCancellation.partialOrderSummaryValue',
    defaultMessage: 'Partial cancellation',
  },
});

export default messages;
